var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2915 12.2211L9.78853 9.71338L1.50607 18.1248C1.58525 18.0949 1.66199 18.0589 1.73562 18.0171L12.2915 12.2211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.322511 1.59717C0.326802 2.6232 0.394023 16.3018 0.400459 17.1643C0.381807 17.3438 0.407546 17.5252 0.475399 17.6924C0.543252 17.8596 0.651127 18.0074 0.789483 18.1229L9.42667 9.352L0.751582 0.657227C0.601866 0.760163 0.482855 0.901999 0.407277 1.06756C0.3317 1.23312 0.3024 1.41619 0.322511 1.59717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7554 6.70166L10.1474 9.34998L12.7583 11.9653L16.3468 9.99434C16.7758 9.75678 17.2321 9.15124 16.3468 8.66692L12.7554 6.70166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73559 0.668741C1.62097 0.607812 1.49612 0.568648 1.36731 0.553223L9.78642 8.98754L12.2893 6.44613L1.73559 0.668741Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6739,
    height: 18.1238,
    fill: "white",
    transform: "translate(0.316177 0.553223)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.1add5081c67091d770c73e0a35cbb66f.svg";
export { ForwardRef as ReactComponent };